import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import Button from 'uikit/Button';

import imageCelebration from './images/celebration.svg';
import styles from './Empty.module.scss';

const cx = classNames.bind(styles);

const Empty = ({ className, handleQuestionCreate, t }) => (
  <div className={cx('container', className)}>
    <img
      alt=""
      aria-hidden="true"
      className={cx('image')}
      src={imageCelebration}
    />
    <h3 className={cx('title')}>{t('Course/Teacher/Editor/Empty/title')}</h3>
    <Button intent="primary" onClick={handleQuestionCreate} size="large">
      {t('Course/Teacher/Editor/Empty/create-question')}
    </Button>
  </div>
);

Empty.propTypes = {
  className: PropTypes.string,
  handleQuestionCreate: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

Empty.defaultProps = {
  className: undefined,
};

export default Empty;
